export const liveChatViewsStyles = `
/* ========================================
   HOME VIEW
   ======================================== */

.liveChat-home-view {
  background: var(--msg-bg-header-gradient);
  position: relative;
  overflow: hidden;
}

.liveChat-home-view::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 600px;
  height: 600px;
  background: var(--msg-bg-header-glow1);
  filter: blur(60px);
  pointer-events: none;
  z-index: 1;
}

.liveChat-home-view::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 500px;
  background: var(--msg-bg-header-glow2);
  filter: blur(60px);
  pointer-events: none;
  z-index: 1;
}

.liveChat-home-scroll {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

.liveChat-home-header {
  padding: var(--spacing-6) var(--spacing-5);
  position: relative;
  z-index: 2;
  flex-shrink: 0;
}

.liveChat-home-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-8);
  position: relative;
  z-index: 2;
}

.liveChat-home-logo {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-lg);
  overflow: visible;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.liveChat-home-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: var(--radius-lg);
}

.liveChat-home-avatars {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-right: var(--spacing-4);
  margin-left: var(--spacing-4);
}

.liveChat-home-avatars:empty {
  display: none;
}

.liveChat-home-welcome {
  display: flex;
  flex-direction: column;
  text-align: left;
  position: relative;
  z-index: 2;
}

.liveChat-home-greeting {
  font-size: clamp(22px, 8vw, 34px);
  font-weight: var(--font-weight-bold);
  color: var(--msg-text);
  line-height: var(--line-height-tight);
  word-break: break-word;
}

.liveChat-home-question {
  font-size: clamp(18px, 6.5vw, 28px);
  font-weight: var(--font-weight-bold);
  color: var(--msg-text);
  line-height: var(--line-height-tight);
  word-break: break-word;
}

.liveChat-home-body {
  flex: 1;
  padding: 0 var(--spacing-5) var(--spacing-5);
  position: relative;
  z-index: 2;
}

.liveChat-home-recent-card {
  background: var(--msg-bg);
  border: 1px solid var(--msg-border);
  border-radius: 10px;
  padding: var(--spacing-3) var(--spacing-4);
  margin-bottom: var(--spacing-2);
  cursor: pointer;
  transition: background var(--transition-base);
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.liveChat-home-recent-card:hover {
  background: var(--msg-bg-hover);
}

.liveChat-home-recent-card-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--msg-text-tertiary);
  margin-bottom: var(--spacing-2);
}

.liveChat-home-recent-card-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}

.liveChat-home-recent-avatar {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: #ffffff;
  overflow: hidden;
}

.liveChat-home-recent-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.liveChat-home-recent-avatar-logo {
  background: var(--msg-bg-surface);
  border: 1px solid var(--msg-border);
  padding: 4px;
}

.liveChat-home-recent-avatar-logo img {
  object-fit: contain;
}

.liveChat-home-recent-card-content {
  flex: 1;
  min-width: 0;
}

.liveChat-home-recent-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  margin-bottom: 2px;
}

.liveChat-home-recent-card-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
}

.liveChat-home-recent-card-time {
  font-size: var(--font-size-xs);
  color: var(--msg-text-tertiary);
  flex-shrink: 0;
}

.liveChat-home-recent-card-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
}

.liveChat-home-recent-card-message {
  font-size: var(--font-size-sm);
  color: var(--msg-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liveChat-home-recent-unread-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--color-primary);
  flex-shrink: 0;
}

.liveChat-home-message-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-3) var(--spacing-5);
  background: var(--msg-bg-surface);
  border: 1px solid var(--msg-border);
  border-radius: 8px;
  color: var(--msg-text);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-normal);
  cursor: pointer;
  transition: all var(--transition-base);
  margin-bottom: var(--spacing-2);
  font-family: inherit;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.liveChat-home-message-btn:hover {
  background: var(--msg-bg-hover);
}

.liveChat-home-message-btn:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-home-continue-btn {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-3);
}

.liveChat-home-continue-btn > svg {
  flex-shrink: 0;
}

.liveChat-home-continue-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  flex: 1;
}

.liveChat-home-continue-label {
  font-size: 0.875rem;
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
}

.liveChat-home-message-subtext {
  font-size: var(--font-size-xs);
  font-weight: 400;
  color: var(--msg-text-secondary);
}

.liveChat-home-continue-preview {
  font-size: var(--font-size-sm);
  opacity: 0.6;
  font-weight: var(--font-weight-normal);
}

.liveChat-home-featured {
  background: var(--msg-bg);
  border-radius: var(--radius-xl);
  overflow: hidden;
  margin-bottom: var(--spacing-5);
  box-shadow: var(--msg-shadow-card);
}

.liveChat-home-featured-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
}

.liveChat-home-featured-divider {
  height: 1px;
  background: var(--msg-border);
}

.liveChat-home-featured-content {
  padding: var(--spacing-4) var(--spacing-5);
}

.liveChat-home-featured-content h3 {
  margin: 0 0 var(--spacing-2);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: var(--line-height-normal);
}

.liveChat-home-featured-content p {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--msg-text-tertiary);
  line-height: var(--line-height-relaxed);
}

.liveChat-home-featured-btn {
  margin-top: var(--spacing-3);
}

.liveChat-home-changelog-section {
  margin-top: var(--spacing-5);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.liveChat-home-changelog-card {
  background: var(--msg-bg-surface);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid var(--msg-border);
  transition: all var(--transition-base);
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.liveChat-home-changelog-card:hover {
  background: var(--msg-bg-hover);
}

.liveChat-home-changelog-card:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-home-changelog-cover {
  width: 100%;
  height: 140px;
  overflow: hidden;
  position: relative;
}

.liveChat-home-changelog-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.liveChat-home-changelog-cover-text {
  position: absolute;
  bottom: var(--spacing-3);
  left: var(--spacing-3);
  right: var(--spacing-3);
  color: #ffffff;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  line-height: var(--line-height-snug);
}

.liveChat-home-changelog-card-content {
  padding: var(--spacing-4);
  border-top: 1px solid var(--msg-border);
}

.liveChat-home-changelog-card-title {
  margin: 0 0 var(--spacing-2);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: var(--line-height-snug);
}

.liveChat-home-changelog-card-desc {
  margin: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-normal);
  color: var(--msg-text-secondary);
  line-height: var(--line-height-relaxed);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.liveChat-home-availability,
.liveChat-chat-availability {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-top: var(--spacing-2);
  font-size: var(--font-size-sm);
  color: var(--msg-text-secondary);
}

.liveChat-availability-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
  align-self: center;
  display: block;
}

.liveChat-availability-online {
  background: var(--color-success);
  box-shadow: 0 0 0 2px var(--color-success-light);
}

.liveChat-availability-away {
  background: var(--color-neutral-400);
}

.liveChat-availability-text {
  opacity: 0.9;
}

/* ========================================
   CONVERSATIONS VIEW
   ======================================== */

.liveChat-conversations-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-3) var(--spacing-5);
  border-bottom: 1px solid var(--msg-border);
  background: var(--msg-bg-header-gradient);
  position: relative;
  overflow: hidden;
}

.liveChat-conversations-header h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  text-align: center;
  flex: 1;
}

.liveChat-conversations-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.liveChat-conversations-list {
  display: flex;
  flex-direction: column;
}

.liveChat-conversation-item + .liveChat-conversation-item {
  border-top: 1px solid var(--msg-border);
}

.liveChat-conversation-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: 10px var(--spacing-4);
  cursor: pointer;
  transition: background var(--transition-base);
}

.liveChat-conversation-item:hover {
  background: var(--msg-bg-hover);
}

.liveChat-conversation-item:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-conversation-avatars {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  align-self: stretch;
}

.liveChat-conversation-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.liveChat-conversation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
  gap: var(--spacing-3);
}

.liveChat-conversation-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liveChat-conversation-time {
  font-size: var(--font-size-sm);
  color: var(--msg-text-tertiary);
  flex-shrink: 0;
}

.liveChat-conversation-preview {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.liveChat-conversation-message {
  font-size: var(--font-size-sm);
  font-weight: 400;
  color: var(--msg-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.liveChat-conversation-item.unread .liveChat-conversation-message {
  color: var(--msg-text);
  font-weight: 500;
}

.liveChat-unread-dot {
  width: 8px;
  height: 8px;
  background: var(--color-primary);
  border-radius: var(--radius-full);
  flex-shrink: 0;
}

.liveChat-conversation-item.closed .liveChat-conversation-title,
.liveChat-conversation-item.closed .liveChat-conversation-message {
  color: var(--msg-text-tertiary);
}

.liveChat-conversation-resolved-badge {
  font-size: 0.6875rem;
  font-weight: 500;
  color: var(--color-success-dark);
  background: var(--color-success-light);
  border-radius: var(--radius-full);
  padding: 1px 7px;
  flex-shrink: 0;
}

.liveChat-conversations-footer {
  border-top: 1px solid var(--msg-border);
}

.liveChat-new-message-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: 12px var(--spacing-4);
  background: transparent;
  border: none;
  color: var(--msg-text);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: background var(--transition-base);
  font-family: inherit;
  text-align: left;
}

.liveChat-new-message-btn:hover {
  background: var(--msg-bg-hover);
}

.liveChat-new-message-btn:active {
  transform: translateX(4px) translateY(1px);
  transition-duration: 100ms;
}

.liveChat-new-message-btn span {
  flex: 1;
  text-align: left;
}

/* ========================================
   HELP VIEW
   ======================================== */

.liveChat-help-header {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-5) var(--spacing-3);
  border-bottom: 1px solid var(--msg-border);
  flex-shrink: 0;
  background: var(--msg-bg-header-gradient);
  position: relative;
  overflow: hidden;
}

.liveChat-help-header::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -20px;
  width: 200px;
  height: 200px;
  background: var(--msg-bg-header-glow1);
  filter: blur(30px);
  pointer-events: none;
}

.liveChat-help-header::after {
  content: '';
  position: absolute;
  top: -10px;
  right: -20px;
  width: 150px;
  height: 150px;
  background: var(--msg-bg-header-glow2);
  filter: blur(25px);
  pointer-events: none;
}

.liveChat-help-header-top {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.liveChat-help-header-top h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
}

.liveChat-help-close-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.liveChat-help-search-wrap {
  position: relative;
  width: 100%;
}

.liveChat-help-search-icon {
  position: absolute;
  left: var(--spacing-3);
  top: 50%;
  transform: translateY(-50%);
  color: var(--msg-text-tertiary);
  display: flex;
  align-items: center;
  pointer-events: none;
}

.liveChat-help-search-input {
  width: 100%;
  background: var(--msg-bg-input);
  border: 1px solid var(--msg-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-2) var(--spacing-3) var(--spacing-2) calc(var(--spacing-3) + 16px + var(--spacing-2));
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-normal);
  color: var(--msg-text);
  font-family: inherit;
  outline: none;
  transition: border-color var(--transition-base), background var(--transition-base);
  box-sizing: border-box;
}

.liveChat-help-search-input:focus {
  border-color: var(--color-primary);
  background: var(--msg-bg);
}

.liveChat-help-search-input::placeholder {
  color: var(--msg-text-tertiary);
}

.liveChat-help-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.liveChat-help-collections-header {
  display: none;
}

.liveChat-help-collections {
  padding: 0;
}

.liveChat-help-collection {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: var(--spacing-3) var(--spacing-5);
  cursor: pointer;
  transition: background var(--transition-base);
  border-bottom: 1px solid var(--msg-border);
}

.liveChat-help-collection:hover {
  background: var(--msg-bg-hover);
}

.liveChat-help-collection:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.liveChat-help-collection-icon {
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--msg-text-secondary);
}

.liveChat-help-collection-icon svg {
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  flex-shrink: 0;
}

.liveChat-help-collection-icon iconify-icon {
  font-size: 1.5rem;
  width: 1em;
  height: 1em;
  display: block;
  flex-shrink: 0;
}

.liveChat-help-collection-content {
  flex: 1;
  min-width: 0;
}

.liveChat-help-collection-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: var(--line-height-snug);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liveChat-help-collection-desc {
  margin: 2px 0 var(--spacing-1);
  font-size: var(--font-size-sm);
  color: var(--msg-text-secondary);
  line-height: var(--line-height-normal);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liveChat-help-collection-meta {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-top: 2px;
}

.liveChat-help-collection-avatar {
  display: none;
}

.liveChat-help-collection-avatar--initials {
  display: none;
  line-height: 1;
}

.liveChat-help-collection-count {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  color: var(--msg-text-tertiary);
}

.liveChat-help-footer {
  padding: var(--spacing-4) var(--spacing-5);
  border-top: 1px solid var(--msg-border);
  text-align: center;
}

.liveChat-help-footer-link {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  text-decoration: none;
  cursor: pointer;
  transition: color var(--transition-base);
}

.liveChat-help-footer-link:hover {
  color: var(--color-primary);
}

/* ========================================
   CHANGELOG VIEW
   ======================================== */

.liveChat-changelog-header {
  padding: var(--spacing-2) var(--spacing-5);
  border-bottom: 1px solid var(--msg-border);
  flex-shrink: 0;
  background: var(--msg-bg-header-gradient);
  position: relative;
  overflow: hidden;
}

.liveChat-changelog-header::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -20px;
  width: 200px;
  height: 200px;
  background: var(--msg-bg-header-glow1);
  filter: blur(30px);
  pointer-events: none;
}

.liveChat-changelog-header::after {
  content: '';
  position: absolute;
  top: -10px;
  right: -20px;
  width: 150px;
  height: 150px;
  background: var(--msg-bg-header-glow2);
  filter: blur(25px);
  pointer-events: none;
}

.liveChat-changelog-header-top {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.liveChat-changelog-header-top h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
}

.liveChat-changelog-close-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.liveChat-changelog-body {
  flex: 1;
  overflow-y: auto;
}

.liveChat-changelog-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-4) var(--spacing-5);
}

.liveChat-changelog-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--msg-border);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow var(--transition-base), transform var(--transition-base);
}

.liveChat-changelog-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

.liveChat-changelog-card:active {
  transform: translateY(0);
  transition-duration: 100ms;
}

.liveChat-changelog-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  padding: var(--spacing-3) var(--spacing-4);
}

.liveChat-changelog-meta {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-wrap: wrap;
}

.liveChat-changelog-date {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  color: var(--msg-text-tertiary);
}

.liveChat-changelog-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-1);
}

.liveChat-changelog-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: var(--font-weight-medium);
  line-height: 1.5;
}

.liveChat-changelog-title {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--msg-text);
  line-height: var(--line-height-snug);
}

.liveChat-changelog-description {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--msg-text-secondary);
  line-height: var(--line-height-normal);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.liveChat-changelog-thumb {
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid var(--msg-border);
}

.liveChat-changelog-thumb img {
  width: 100%;
  height: 180px;
  display: block;
  object-fit: cover;
}
`;
